import React from "react";
import { IoIosCheckboxOutline } from "react-icons/io";
import "./KeyBenefitPopup.css";

const KeyBenefitPopup = ({ onClose, keyBenifits, isOpen = true }) => {
  if (!isOpen) return null;

  const filtered =
    keyBenifits?.filter(
      (b) =>
        b.CoverageDisplayName !== "" &&
        b.CoverageDisplayName !== "Total Premium",
    ) || [];

  return (
    <div
      className="kb-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
      role="dialog"
      aria-modal="true"
    >
      <div className="kb-modal">
        {/* Header */}
        <div className="kb-header">
          <div className="kb-header-left">
            <div className="kb-header-icon">
              <IoIosCheckboxOutline />
            </div>
            <span className="kb-title">Key Benefits</span>
            <span className="kb-count-badge">{filtered.length} items</span>
          </div>
          <button
            type="button"
            className="kb-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <svg
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 16 16"
            >
              <path d="M3 3l10 10M13 3L3 13" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {/* Table */}
        <div className="kb-table-wrap">
          <table className="kb-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Coverage</th>
                <th>Limit</th>
                <th>Deductible</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((benefit, index) => (
                <tr key={index}>
                  <td className="kb-sno">{index + 1}</td>
                  <td className="kb-coverage">{benefit.CoverageDisplayName}</td>
                  <td className="kb-limit">
                    {benefit.Limit === "" ? (
                      <span className="kb-na">NA</span>
                    ) : (
                      benefit.Limit
                    )}
                  </td>
                  <td className="kb-deductible">
                    {benefit.Deductible === "" ? (
                      <span className="kb-na">NA</span>
                    ) : benefit.Deductible === "Nil" ? (
                      <span className="kb-nil">Nil</span>
                    ) : (
                      benefit.Deductible
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="kb-footer">
          <span className="kb-footer-note">
            Values may vary based on policy terms
          </span>
          <button type="button" className="kb-footer-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default KeyBenefitPopup;
